import React, {
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState
} from "react";
import axios from "axios";
import {
    Link
} from "react-router-dom";
import {
    OverlayTrigger,
    Tooltip
} from "react-bootstrap";
import {
    TabBar,
    TabBarItem,
    Title
} from "@zandor300/backoffice-framework";
import ReactRouterPropTypes from "react-router-prop-types";

import ShopsContext from "../../context/ShopsContext";
import TagPill from "../../components/pills/TagPill";
import Helmet from "../../components/Helmet";
import ProductsTable from "./ProductsTable";

function Products({ match }) {
    const shopsContext = useContext(ShopsContext);
    const [products, setProducts] = useState(null);
    const [error, setError] = useState(null);

    const baseUrl = "/shop/" + shopsContext.currentShop.codeName;

    const filter = useMemo(() => {
        const filters = [
            "all",
            "active",
            "archived"
        ];
        if(!match.params.filter) {
            return "active";
        }
        if(!filters.includes(match.params.filter)) {
            return null;
        }
        return match.params.filter.toLowerCase();
    }, [match.params.filter]);

    const getProducts = useCallback(async () => {
        setProducts(null);
        setError(null);
        try {
            const response = await axios.post("/getProducts", {
                shopId: shopsContext.currentShop.id,
                filter,
            });
            const sortedProducts = response.data.products.sort((product1, product2) => {
                return product1.name > product2.name ? 1 : -1;
            });
            setProducts(sortedProducts);
        } catch(requestError) {
            console.error(requestError);
            setError("Er ging iets fout. Probeer het later opnieuw.");
        }
    }, [filter]);

    useEffect(() => {
        getProducts();
    }, [getProducts]);

    return (
        <React.Fragment>
            <Helmet title="Producten"/>
            <Title
                noBottom
                preTitle="Overzicht"
                preChildren={
                    <div className="float-right mt-2">
                        <OverlayTrigger overlay={
                            <Tooltip id="newProduct">Nieuw product</Tooltip>
                        }>
                            <Link
                                to={ baseUrl + "/products/add" }
                                className="btn btn-secondary float-right mt-2"
                            >
                                <i className="fas fa-fw fa-plus"/>
                            </Link>
                        </OverlayTrigger>
                    </div>
                }
            >
                Producten
                <small>
                    <TagPill className="ml-2">{ products ? products.length : 0 }</TagPill>
                </small>
            </Title>
            <TabBar noBottom>
                <TabBarItem to={ baseUrl + "/products" }>
                    Actief
                </TabBarItem>
                <TabBarItem to={ baseUrl + "/products/archived" }>
                    Gearchiveerd
                </TabBarItem>
                <TabBarItem to={ baseUrl + "/products/all" }>
                    Alle
                </TabBarItem>
            </TabBar>
            <ProductsTable
                products={ products }
                error={ error }
                baseUrl={ baseUrl }
            />
        </React.Fragment>
    );
}
Products.propTypes = {
    match: ReactRouterPropTypes.match,
};

export default React.memo(Products);
